export default __webpack_public_path__ + "static/media/explore-iv-banner-1.895f7d08.png";